// extracted by mini-css-extract-plugin
export default {"container":"slideUp_container__SLgiq","wrap":"slideUp_wrap__70YI5"};